module.exports = __webpack_public_path__ + "logo.png?f0a337bd8e4ee532e6996a900d4391b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 238
// module chunks = 0